import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ProductsSection from "@/components/ProductsSection";
import CatalogueTeaser from "@/components/CatalogueTeaser";
import AboutCompany from "@/components/AboutCompany";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

const Home = () => {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <ProductsSection />
        <CatalogueTeaser />
        <AboutCompany />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
